export default {"src":"/_next/static/media/Chicken.ccd46bcb.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};